export const changePurchaseGradeReducer = (state = '', action) => {
    switch (action.type) {
      case "CHANGE_PURCHASE_GRADE":
        return action.payload.purchaseGrade;
      default:
        return state;
    }
  };
  